import styled from 'styled-components'

export const SideNavigationContent = styled.div`
  padding: ${({ theme }) => theme.spacing.xl}px
    ${({ theme }) => theme.spacing.lg}px;
  overflow: hidden;
  flex-grow: 1;
`
